import React, { useState } from 'react'
import agentImg from '../../../asset/images/IBA/AgentImg.svg'
import IBAAgentModalCommon from '../../IBAAgentModalCommon'

const AgentIdDetails = ({onEditClick}) => {
    const [modalHide, setModalHide] = useState(false)
    return (
        <div className='agent-card-wrapper'>
            <div className='agent-id'>
                <div className='agent-name'>
                    <img src={agentImg} alt='agentImg' />
                    <div>
                        <h3>Avinash Shukla</h3>
                        <span>Agent</span>
                    </div>
                </div>
                <div className='agent-id-pass'>
                    <div className='userid'>
                        <span className='id-number'>User Id :</span>
                        <span className='agent-number'></span>
                    </div>
                    <div className='userid'>
                        <span className='id-number'>Password :</span>
                        <span className='agent-number'></span>
                    </div>
                </div>
                <div className='agent-id-pass'>
                    <div className='userid'>
                        <span className='id-number'>Phone number:</span>
                        <span className='agent-number'></span>
                    </div>
                    <div className='userid'>
                        <span className='id-number'>Tier Name :</span>
                        <span className='agent-number'> L1</span>
                    </div>
                </div>
                <div className='agent-button'>
                    <div className='button-deactivate'>
                        <button className="deactivate">Deactivate</button>
                    </div>
                    <div className='button-deactivate'>
                        <button className='edit'onClick={() => onEditClick("profile", "")}>Edit</button>
                    </div>
                </div>
            </div>
            {modalHide && <IBAAgentModalCommon setModalHide={setModalHide} modalHide={modalHide} />
            }

        </div>
    )
}

export default AgentIdDetails